import React, { Component } from 'react';
import { Modal, Grid, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';

export class DayDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: props.day
        }
    }

    // -------------------

    render() {
        const { day } = this.state;
        
        if (undefined === day || null === day) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Detalhes - {day.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <Row className="padding-top-7">
                            <Col sm={4} md={3} className="details-label">Nome</Col>
                            <Col sm={8} md={9}>{day.name}</Col>
                        </Row>
                        <Row className="padding-top-7">
                            <Col sm={4} md={3} className="details-label">Data</Col>
                            <Col sm={8} md={9}>{day.date}</Col>
                        </Row>
                        <Row className="padding-top-7">
                            <Col sm={4} md={3} className="details-label">Tipo de Dia</Col>
                            <Col sm={8} md={9}>{day.dayTypeName}</Col>
                        </Row>
                    </Grid>
                    <ButtonToolbar className="margin-top-15">
                        <Button onClick={() => this.props.onEdit(day)}> EDITAR </Button>
                        <Button onClick={() => this.props.onDelete(day)}> ELIMINAR </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
